import { Injectable } from '@angular/core';
import { ApiEnvironmentService } from '../api-environment.service';
import { LocationsRequest } from '../common';
import { OrganTransplantTypes } from '../organ-transplant/organ-transplant.model';

@Injectable()
export class ApiBuilder {
  constructor(private apiService: ApiEnvironmentService) {}
  public buildUrl(request: LocationsRequest, apiMethod: string): string {
    const apiBaseHref = this.apiService.getApiBaseHref();
    let url = `${apiBaseHref}/${apiMethod}/find?lon=${request.lon}&lat=${request.lat}&radius=${request.radius}`;
    if (request.heathCenter) {
      url = `${url}&healthCenter=${request.heathCenter}`;
    }
    if (apiMethod === 'opo') {
      const organList = [];
      if (request.checkBoxData) {
        if (request.checkBoxData['all']) {
          url = `${url}&includeOpos=false&includeOtcs=true`;
        } else {
          Object.keys(request.checkBoxData).forEach(key => {
            if (key !== 'all' && request.checkBoxData[key]) {
              const match = OrganTransplantTypes.find(item => {
                return item.id === key;
              });
              organList.push(match.value);
            }
          });

          if (organList.length) {
            url = `${url}&includeOpos=true&includeOtcs=false`;
            url = `${url}&organList=${organList.join()}`;
          }
        }
      }
    }
    return url;
  }
}
